"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * HEM Workbench API Specification
 * Health Economics Workbench API Specification
 *
 * The version of the OpenAPI document: 2.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ScenarioExecutionDTOAllOfToJSON = exports.ScenarioExecutionDTOAllOfFromJSONTyped = exports.ScenarioExecutionDTOAllOfFromJSON = void 0;
const runtime_1 = require("../runtime");
const _1 = require("./");
function ScenarioExecutionDTOAllOfFromJSON(json) {
    return ScenarioExecutionDTOAllOfFromJSONTyped(json, false);
}
exports.ScenarioExecutionDTOAllOfFromJSON = ScenarioExecutionDTOAllOfFromJSON;
function ScenarioExecutionDTOAllOfFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return Object.assign(Object.assign({}, json), { 'status': !runtime_1.exists(json, 'status') ? undefined : _1.ExecutionStatusFromJSON(json['status']) });
}
exports.ScenarioExecutionDTOAllOfFromJSONTyped = ScenarioExecutionDTOAllOfFromJSONTyped;
function ScenarioExecutionDTOAllOfToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return Object.assign(Object.assign({}, value), { 'status': _1.ExecutionStatusToJSON(value.status) });
}
exports.ScenarioExecutionDTOAllOfToJSON = ScenarioExecutionDTOAllOfToJSON;
